import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { ButtonModule } from 'primeng/button';
import { PwaHandshakeService } from '../pwa-handshake.service';

@Component({
  selector: 'app-feature-not-available',
  standalone: true,
  imports: [CommonModule,ButtonModule],
  templateUrl: './feature-not-available.component.html',
  styleUrl: './feature-not-available.component.css'
})
export class FeatureNotAvailableComponent {
  constructor(private router:Router, 
              private pwaHandshakeService: PwaHandshakeService) {}
  retry() {
    this.pwaHandshakeService.done();
    //this.router.navigate(['/unavailable']);
    console.log('Retry clicked');
  }

}
